import authenticatedInstance from "./AxiosInstance/authenticated";
import { toast } from 'sonner'

export const handlePayment = async (plan) => {
    const response = await authenticatedInstance.post("/create-checkout-session", {
        // lookup_key: event.target.lookup_key.value,
        plan: plan
    });

    const url = response.data;
    window.location.href = url;
    // if (setLoading) {
    //     setLoading(null);
    // }
}


export const handleOneTimePayment = (priceId) => {
    return async (dispatch) => {

        const response = await authenticatedInstance.post("/one-time-checkout-session", {
            // lookup_key: event.target.lookup_key.value,
            priceId: priceId
        });
        console.log(response.data)
        const url = response.data;
        window.location.href = url
    }
}


const PORTAL_SAFE_TOAST_MESSAGES = new Set([
    "No billing account found",
    "Unable to open billing portal. Please try again later.",
]);

function portalErrorToast(error) {
    const raw = error?.response?.data?.message;
    if (typeof raw === "string" && PORTAL_SAFE_TOAST_MESSAGES.has(raw)) {
        toast.error(raw);
        return;
    }
    toast.error("Could not open billing portal");
}

async function createCustomerPortalSession({ returnPath, setLoading }) {
    try {
        const { data } = await authenticatedInstance.post("/create-customer-portal-session", {
            ...(returnPath != null ? { returnPath } : {}),
        });
        const url = typeof data === "string" ? data : data?.url;
        if (!url) {
            toast.error("Could not open billing portal");
            return;
        }
        window.location.href = url;
    } catch (error) {
        portalErrorToast(error);
    } finally {
        if (setLoading) {
            setLoading(null);
        }
    }
}

export const openPaymentSettingsPortal = async ({ setLoading, returnPath } = {}) => {
    await createCustomerPortalSession({
        returnPath: returnPath ?? "/settings",
        setLoading,
    });
};

export const handlePortalSession = async (setLoading) => {
    await createCustomerPortalSession({ returnPath: "/dashboard", setLoading });
};


export const creditsData = () => async (dispatch) => {
    try {
        const { data, status } = await authenticatedInstance.get('/creditsData')

        console.log(data, "data")
        if (status === 200) {
            dispatch({
                type: "UPDATE_STRIPE",
                payload: data,
            });

            dispatch({
                type: "UPDATE_CURRENT_PLAN",
                payload: data?.currentPlan,
            });

            dispatch({
                type : "SHOW_SUBSCRIBE_MODAL",
                payload : data?.showSubscriptionModal,
            })
        }
    } catch (error) {
        console.log(error, "Error in get settings")
        toast.error("Couldn't update credits")
    }
}